module.exports = __webpack_public_path__ + "static/media/ss-02.5bec6f8a.png";